const ONE_MINUTE_IN_SECONDS = 60;
export const secondsToMinutes = (seconds) => Math.round(seconds / ONE_MINUTE_IN_SECONDS);
